import User from '@/generated/classes/User';
import { storeSession } from '@/generated/stores';

export enum EnumProfile {
  superAdmin = 0x01,
  admin = 0x02,
  user = 0x04,
  client = 0x08,
  adminClient = 0x10,
  salarie = 0x20,
  support = 0x40,
  signatory = 0x80,
  compta = 0x100,
  marketing = 0x200,
  ci98 = 0x400,
  canEdit = 0x800
}

export default class UserProfile {
  public static hasProfile (user: User, profil: EnumProfile): boolean {
    return (user.currentProfil & profil) > 0;
  }

  public static canEditResources (user: User): boolean {
    return true;
    // return (user.profil & (EnumProfile.canEdit + EnumProfile.superAdmin)) > 0;
  }


  public static userInterne = EnumProfile.superAdmin + EnumProfile.admin + EnumProfile.support + EnumProfile.compta + EnumProfile.marketing;

  public static hasMultipleProfile (user: User): boolean {
    let res = 0;
    if ((user.profil & EnumProfile.client) > 0) {
      res++;
    }
    if ((user.profil & EnumProfile.salarie) > 0) {
      res++;
    }
    if ((user.profil & UserProfile.userInterne) > 0) {
      res++;
    }
    return res > 1;
  }

  public static IsInterne (user: User) {
    return ((user.profil & UserProfile.userInterne) > 0);
  }

  public static get isSalarie (): boolean {
    let res = false;
    const user = storeSession.connectedUser;
    if (user) {
      res = UserProfile.hasProfile(user, EnumProfile.salarie);
    }
    return res;
  }

  public static get isClient (): boolean {
    let res = false;
    const user = storeSession.connectedUser;
    if (user) {
      res = UserProfile.hasProfile(user, EnumProfile.client);
    }
    return res;
  }

  public static listProfile (user: User): EnumProfile[] {
    const res = [];
    if ((user.profil & EnumProfile.client) > 0) {
      res.push(EnumProfile.client)
    }
    if ((user.profil & EnumProfile.salarie) > 0) {
      res.push(EnumProfile.salarie)
    }
    if ((user.profil & UserProfile.userInterne) > 0) {
      res.push(EnumProfile.admin)
    }
    return res;
  }
}

